module.exports = __webpack_public_path__ + "static/media/blog1_sm.ea655d1b.webp";